import React, {  } from 'react';
import Avatar from 'react-avatar';
import { Link } from 'react-router-dom';
import { Header, Icon } from 'semantic-ui-react';
import { StringUtils } from 'utils';
import "./index.scss"
import { ClippedContent } from 'dyl-components/atoms/ClippedContent';

const STAGE_ICONS = {
    opportunity: "fa-solid fa-funnel-dollar",
    lead: "fa-solid fa-id-card",
    customer: "fa-solid fa-user-crown"
}

const OfficeViewCallerDetails = ({
    person,
    onRemovePerson,
    callState,
    unknown,
    isInternalCall,
    currentCall,
    currentCallUUID,
    isDialer,
    isArchived
}) => {
    const isConferenceRoom = currentCall?.company_destination?.substr(0,1) !== '7' || currentCall?.call_type !== "dialphone";

    const isCallActive = callState === "active";
    const isCallRinging = callState === "ringing";
    const isCallNotIdle = isCallActive || isCallRinging;
    const isUnknown = unknown.unknown;
    return (
        <div style={{ display: 'flex' }} data-uuid={currentCallUUID}>
            {isArchived ? (
                <Header as={"h1"} className={`OfficeView__${isConferenceRoom ? "unknownName" : "conferenceRoom"}`}>
                    {person.name}
                </Header>
            ) : (
                !isUnknown ?
                <Avatar
                    size={isDialer ? '3.5em' : '5em'}
                    round
                    maxInitials={2}
                    name={person.name}
                    style={{ marginRight: isDialer ? 10 : 15 }} />
                : isConferenceRoom ?
                    <div className='OfficeView__roundAvatar' style={isDialer ? { height: '3.5em', width: '3.5em', marginRight: 10 } : undefined}>
                        <Icon name="user" size={isDialer ? undefined : 'big'} style={{ marginLeft: "3px" }} className='onHoverOnClick__white' />
                    </div> : ""
            )}
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', flexDirection: 'column', ...(isDialer ? { minWidth: 0 } : {}) }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ flex: 1, ...(isDialer ? { minWidth: 0 } : {}) }}>
                        <div style={isDialer ? undefined : { width: 'fit-content' }}>
                            {!isUnknown ? (
                                <Header as={!isDialer ? "h1" : "h3"} className='OfficeView__headerName'>
                                    {isDialer ? (
                                        <ClippedContent popupContent={person.name}>
                                            <Link to={person.contact_id ? `/contact/${person.contact_id}` : person.account_id ? `/account/${person.account_id}` : `/settings/users/${person.user_id}/general`} target='_blank' rel='noopener noreferrer'>
                                                {person.name}
                                            </Link>
                                        </ClippedContent>
                                    ) : (
                                        <Link to={person.contact_id ? `/contact/${person.contact_id}` : person.account_id ? `/account/${person.account_id}` : `/settings/users/${person.user_id}/general`} target='_blank' rel='noopener noreferrer'>
                                            {person.name}
                                        </Link>
                                    )}
                                </Header>
                            ) : (
                                <Header as={"h1"} className={`OfficeView__${isConferenceRoom ? "unknownName" : "conferenceRoom"}`}>
                                    {!unknown.name ? 'Unknown' : (
                                        isDialer ? (
                                            <ClippedContent>
                                                {unknown.name}
                                            </ClippedContent>
                                        ) : unknown.name
                                    )}
                                </Header>
                            )}
                        </div>
                    </div>
                    {!isDialer && <Icon name='x' size='big' className='OfficeView__closeHeaderIcon' disabled={isCallNotIdle} onClick={onRemovePerson} style={{ cursor: "pointer" }} />}
                </div>
                {(!isInternalCall && !isUnknown) &&
                    <>
                        <div style={{ display: 'flex', gap: 15 }}>
                            <div>
                                <Icon
                                    className={`fa-solid ${person?.contact_id ?
                                        ("fa-user") :
                                        (person?.account_details?.account_type === "business" ? "fa-buildings" : "fa-house-chimney")
                                    }`}
                                    style={{ marginRight: 6 }} 
                                />
                                <strong>{person.contact_id ? "Contact" : "Account"}</strong>
                            </div>
                            {!isInternalCall && person?.contact_id ? (
                                <>
                                    {person.contact_details?.job_title && (
                                        <div {...(isDialer ? { style: { maxWidth: 125 } } : {})}>
                                            <ClippedContent>{person.contact_details?.job_title}</ClippedContent>
                                        </div>
                                    )}
                                    {!isDialer && person.contact_details?.pipeline_stage && (
                                        <div>
                                            <Icon className={STAGE_ICONS[person.contact_details?.pipeline_stage]} style={{ marginRight: 6 }} />
                                            <strong>{StringUtils.capitalize(person.contact_details?.pipeline_stage || "") || ""}</strong>
                                        </div>
                                    )}
                                </>
                            ) : (person?.account_details?.customer && (
                                <div>
                                    <Icon className='fa-solid fa-user-crown' style={{ marginRight: 6 }} />
                                    <strong>Customer</strong>
                                </div>
                            ))}
                        </div>
                        {isDialer && (
                            !isInternalCall && person?.contact_id && person.contact_details?.pipeline_stage ? (
                                <div>
                                    <Icon className={STAGE_ICONS[person.contact_details?.pipeline_stage]} style={{ marginRight: 6 }} />
                                    <strong>{StringUtils.capitalize(person.contact_details?.pipeline_stage || "") || ""}</strong>
                                </div>
                            ) : (person?.account_details?.customer && (
                                <div>
                                    <Icon className='fa-solid fa-user-crown' style={{ marginRight: 6 }} />
                                    <strong>Customer</strong>
                                </div>
                            ))
                        )}
                    </>
                }
                {!isConferenceRoom &&
                    <div style={{ display: 'flex', gap: 15, marginTop: 10 }}>
                        <div>
                            <Header as={"h3"}> Ext. {currentCall?.company_destination || ""}</Header>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default OfficeViewCallerDetails;
